import { PasswordRegExpManager } from '@speeki/utils';

import i18n from '@services/TranslationsService/i18n';

interface InputRequirement {
    regexp: RegExp;
    title: string;
}

export const passwordRequirements: InputRequirement[] = [
    {
        regexp: PasswordRegExpManager.lowercase,
        title: i18n.t('PASSWORD_VALIDATION_LOWERCASE'),
    },
    {
        regexp: PasswordRegExpManager.min_max_length,
        title: i18n.t('PASSWORD_VALIDATION_LENGTH'),
    },
    {
        regexp: PasswordRegExpManager.min_number,
        title: i18n.t('PASSWORD_VALIDATION_NUMBER'),
    },
    {
        regexp: PasswordRegExpManager.min_symbol,
        title: i18n.t('PASSWORD_VALIDATION_SYMBOL'),
    },
    {
        regexp: PasswordRegExpManager.uppercase,
        title: i18n.t('PASSWORD_VALIDATION_UPPERCASE'),
    },
];
